module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buttonLabel":"Get a Sponsor\\n Licence"}}')
  delete Component.options._Ctor
}
